import { AssignTasks } from '../../modules/AssignTasks';
import { appConfig as $config } from '../../app.config';
import { UI } from '../../modules/UI';
import { Common } from '../../modules/Common';
import { App } from '../../modules/App';
import { User } from '../../modules/User';
import { LabelSize } from '../../modules/LabelSize';
import { ValidationRules } from '../../modules/ValidationRules';
import { SortFilter } from '../../modules/SortFilter';
import { QuickFilters } from '../../modules/SortFilter/quick-filters';
import { assetsManager } from '../../modules/assetsManager';

import './scss/trims.scss';
import { ApprovalRejection } from '../../modules/ApprovalRejection';
import { Artworks } from '../Artworks';

export const Trims = (function () {
  let $isLicensor = '';
  let $withArtworks = false;

  let mapping = {
    trimsOrStamps: (data) => {
      return $.map(data, function (trim) {
        if (trim.files) {
          for (let i = 0; i < trim.files.length; i++) {
            if (trim.files[i].fileType == 0) {
              trim.smalImage = trim.files[i].uri;
            }
            if (!trim.thumbnailImageUri && trim.files[i].fileType == 1) {
              trim.thumbnailImageUri = trim.files[i].uri;
            }
          }
        }
        trim.apiUrl = $config.apiURL;
        trim.accountName = User.accountData().name;
        trim.createDateText = moment(trim.createdDate).format($config.appFullDateFormat);
        // Approval Item mapping
        trim.approveItem = Common.mapping.approvalObject(trim.approveItem);
        return trim;
      });
    },
    trimEdit: (res, isLicensor) => {
      const data = res.object;

      if (data.files) {
        for (let i = 0; i < data.files.length; i++) {
          data.isHaveLow = data.isHaveLow || (data.files[i].fileType == 0 && data.files[i].uri != '');
          data.isHaveHight = data.isHaveHight || (data.files[i].fileType == 1 && data.files[i].uri != '');
          data.isHaveAi = data.isHaveAi || (data.files[i].fileType == 2 && data.files[i].uri != '');
        }
      } else {
        data.files = [];
      }

      let labelSize = data.labelSize ? data.labelSize : LabelSize.newModel();
      let licensor = $storage.get($config.storagekey.licensor);

      return {
        ...data,
        ...{
          accountName: User.accountData().name,
          files: data.files,
          labelSize: labelSize,
          accountDelegations: isLicensor ? licensor : res.accountDelegations,
        }
      };
    },
    defaults: (data) => {
      let newArr = [];
      $.each(data, function (k, v) {
        newArr[v.key] = v.values;
      });
      return newArr;
    },
    trimEditPage: (data, isLicensor) => {
      let trim = mapping.trimEdit(data, isLicensor);
      let defaults = mapping.defaults(data.defaults);

      return {
        trim,
        defaults,
        isLicensor,
        isLicensorSelectDisabled: isLicensor || !!data?.object?.id || !data?.object?.accountId,
      };
    },
    labelSize: (data) => {
      return {
        measurementUnit: data.labelSizeMeasurementUnit,
        height: data.labelSizeHeight,
        width: data.labelSizeWidth
      };
    },
    trimSave: (data) => {
      const clonedFormData = { ...data };
      delete clonedFormData.licensorId;

      const licensor = $storage.get($config.storagekey.licensor);
      const accountId = $isLicensor ? licensor?.[0]?.id : data.licensorId;

      const trim = App.pageData('trim');

      return {
        ...clonedFormData,
        accountId: accountId || trim?.accountId
      };
    }
  };

  let init = (params = {}, query = '') => {
    $withArtworks = params.withArtworks
    $isLicensor = User.isLicensor();

    QuickFilters.setSyncFilters({
      licensorFilters: ['Brand', 'Subbrand', 'LicenseOwner'],
      licenseeFilters: ['Licensor', 'Brand', 'Subbrand'],
    });

    if (!params || (params && params.action != 'dialog')) {
      UI.block('#page');
    } else {
      UI.block('.modal-content');
    }

    if (params && params.action && params.id) {
      if (params.action == 'edit') {
        return editPage(params.id, params.accountId);
      } else if (params.action == 'add') {
        return editPage();
      }
    }

    loadData(params, query);
  };

  let loadData = (params = {}, query = '') => {
    let requestData = {
      requestPage: 'trims'
    };
    if (params && params.action == 'dialog') {
      requestData.requestPage = params.typeModal ? params.typeModal : 'trims';
      App.pageData('typeModal', requestData.requestPage);
      App.pageData('trimsonly', params.trimsonly || false);
    }

    let selectAllTrims = App.pageData('selectAllTrims') || false;
    let selectTrims = App.pageData('selectTrims') || [];

    $.when(App.ajaxData(`${requestData.requestPage}/filter`, requestData, 'POST')).done((pageData) => {
      // Page Data
      pageData.trims = mapping.trimsOrStamps(pageData.data);
      pageData.isLicensor = $isLicensor;

      if (params && params.pagereload) {
        let template = require('./tmpl/partial/content.hbs');
        UI.render('#pageContentTrims', template, pageData).then(() => {
          App.pageData('selectTrims', selectTrims);
          App.pageData('selectAllTrims', selectAllTrims);
          pageinit({ pagereload: true });
        });

        return;
      }

      if (params && params.action == 'dialog') {
        let trimsOrStamps = $.map(pageData.trims, (e) => {
          e.typeModal = params.typeModal ? params.typeModal : 'trims';
          return e;
        });
        App.pageData('trimsOrStamps', trimsOrStamps);
        App.pageData('trims', pageData.trims);
        App.pageData('callback', params.callback);
        pageData = {
          ...pageData,
          ...{
            dialog: true,
            withArtworks: $withArtworks,
            callback: params.callback,
            reload: params.reload,
            query: query,
            $lang: $lang,
            typeModal: params.typeModal,
            trimsonly: params.trimsonly
          }
        };
        return dialogPage(pageData);
      }

      let template = require('./tmpl/trims.hbs');
      UI.page(template, pageData).then(() => {
        App.pageData('selectAllTrims', selectAllTrims);
        App.pageData('selectTrims', selectTrims);
        pageinit(pageData);
      });
    });
  };

  let dialogPage = (pageData) => {
    let typeModal = App.pageData('typeModal') || 'trims';

    let template = require('./tmpl/trims.hbs');
    if (pageData.reload) {
      UI.render('.modal-trimsOrStamp-page .bootbox-body', template, pageData).then(() => {
        App.pageData('trimsonly', pageData.trimsonly || false);
        App.pageData('typeModal', typeModal);
        pageinit(pageData);
      });
      return;
    }

    bootbox.hideAll();

    bootbox
      .dialog({
        title: typeModal == 'trims' ? $lang.ministu.SelectTrim : $lang.ministu.SelectHangtag,
        message: template(pageData),
        animate: false,
        size: 'xl',
        className: 'modal-scrolled-content modal-trimsOrStamp-page',
        buttons: {
          Ok: {
            label: `<i class="fal fa-check-double"></i> ${$lang.btn.applay}`,
            className: 'btn btn-primary',
            callback: pageData.callback
          },
          Close: {
            label: `<i class="fal fa-times"></i> ${$lang.btn.cancel}`,
            className: 'btn btn-link'
          }
        }
      })
      .init(() => {
        App.pageData('typeModal', typeModal);
        pageinit(pageData);
      })
      .on('hide.bs.modal', () => {
        // Clear filters on dialog close
        SortFilter.clear(typeModal);
      });
  };

  let pageinit = (pageData) => {
    // Images ZOOM-IN
    UI.zoomInInit('zoomimage');

    // Page in dialog
    if (pageData.dialog) {
      Common.paginationDialog({
        paginationWraper: '.trimsPaging',
        pagename: pageData.typeModal ? pageData.typeModal : 'trims',
        action: reloadDialogWithClearingSelectAll
      });

      SortFilter.init({
        selector: '#trimsSearchForm',
        pagename: pageData.typeModal ? pageData.typeModal : 'trims',
        update: reloadDialogWithClearingSelectAll
      });

      $('.modal-trimsOrStamp-page .modal-body').scrollTop(0);
      UI.unblock('.modal-content');

      $('.js-action-goToArtworks').on('click', goToArtworks.bind(this, pageData));

      // Standart Page
    } else {
      QuickFilters.init({ selector: '#trimsQuickFilters' });

      // Reload content
      if (pageData.pagereload) {
        SortFilter.updateCheckBoxLists();
        UI.unblock('#page');
        return;
      } else {
        $('#page')
          .off()
          .on('click', '.js-action-assigntask', assignTask)
          .on('click', '.js-action-approvereject', approveReject);

        SortFilter.init({
          selector: '#trimsSearchForm',
          update: reloadPageWithClearingSelectAll,
          isLicensorSelect: true
        });

        $('input[type="checkbox"][name="selectAll"]').off().on('change', selectAll);
      }

      UI.unblock('#page');
    }
  };

  let reloadPageWithClearingSelectAll = () => {
    App.pageData('selectTrims', []);
    App.pageData('selectAllTrims', false);
    reloadPage();
  };

  let reloadDialogWithClearingSelectAll = () => {
    App.pageData('selectTrims', []);
    App.pageData('selectAllTrims', false);
    reloadDialog();
  };

  let reloadPage = () => {
    App.ajaxAbortAll();
    UI.block('#page');
    loadData({ pagereload: true });
  };

  let reloadDialog = (query = '') => {
    UI.block('.modal-content');
    loadData(
      { action: 'dialog', reload: true, typeModal: App.pageData('typeModal'), trimsonly: App.pageData('trimsonly') },
      query
    );
  };

  let assignTask = (e) => {
    AssignTasks.handleAssignTask({
      e: e,
      elClassName: 'js-action-assigntask',
      selectedPageField: 'selectTrims',
      requestPage: 3
    });
  };

  let trimsLoadDialog = (query = '') => {
    UI.block('.modal-content');
    loadData({ action: 'dialog', /*reload: true, */ typeModal: 'trims', callback: App.pageData('callback') }, query);
  };

  let stampsLoadDialog = (query = '') => {
    UI.block('.modal-content');
    loadData({ action: 'dialog', /*reload: true, */ typeModal: 'stamps', callback: App.pageData('callback') }, query);
  };

  let editPage = (id = false, accountId = '') => {
    App.pageData('currenteditedcontent', {});
    let queryPath = id ? `/trims/${accountId}/${id}` : `/trims/emptyTrim/${User.accountID()}`;
    $.when(App.ajaxData(queryPath))
      .done((res) => {
        let pageData = mapping.trimEditPage(res, $isLicensor);
        let template = require('./tmpl/trimEdit.hbs');
        let areaSizes = res.defaults.find((def) => def.key === 'ImageAreaSize').values;
        UI.page(template, pageData).then(() => {
          App.pageData('currenteditedcontent', pageData);
          editPageInit(pageData, areaSizes);
        });
      })
      .always((error) => {
        App.pageData($config.GLOBAL.UNSAVED_CHANGES, false);
        UI.unblock('#page');
      });
  };

  let editPageInit = (pageData, areaSizes) => {
    let aM = assetsManager.init({
      files: [...pageData.trim.files],
      checkedPartTypes: pageData.trim.checkedPartTypes,
      pageType: 'Trims',
      areaSizes: areaSizes,
      update: (result) => {
        App.pageData('currenteditedcontent.files', result.files);
        App.pageData('currenteditedcontent.checkedPartTypes', result.checkedPartTypes);
      }
    });
    App.pageData('currenteditedcontent.files', aM.getFiles().files);

    $('#page')
      .off()
      .on('change', '#trimDialogForm .form-control', () => {
        App.pageData($config.GLOBAL.UNSAVED_CHANGES, true);
      });

    let $form = $('#trimDialogForm');

    $('.form-control-select2', $form).select2();

    $('.js-trim-save').on('click', trimFormSubmit);
    $('.js-trim-cancel').on('click', (e) => {
      App.pageData($config.GLOBAL.UNSAVED_CHANGES, false);
      $router.push({
        pathname: '/trims',
        query: { restoreQuery: null }
      });
    });

    // Autocomplete
    teapaheadInit();

    UI.unblock('#page');
  };

  const teapaheadInit = () => {
    let throttledBrandRequest = _.debounce(function (query, processSync, processAsync) {
      const accountId = $('[name="licensorId"]', $('#trimDialogForm')).val();

      $.when(
        App.ajaxData(`Autocompele/get?propertyName=brand&term=${query}&accountId=${accountId}&requestPage=trims`)
      ).done((res) => processAsync(res?.items?.map(i => i.propertyValue)));
    }, 300);

    $('[name="brand"]').typeahead(
      {
        hint: true,
        highlight: true,
        minLength: 1
      },
      {
        name: 'brand',
        async: true,
        source: function (query, processSync, processAsync) {
          throttledBrandRequest(query, processSync, processAsync);
        },
        templates: {
          empty: '<div>no result</div>',
          pending: '<div>Please wait...</div>'
        }
      }
    );

    $('[name="brand"]').bind('typeahead:change', function (ev, suggestion) {
      setTimeout(function () {
        $('[name="subBrand"]').typeahead('val', '');
      }, 100);
    });
  };

  let trimFormSubmit = () => {
    let $form = $('#trimDialogForm');
    $form.validate({ rules: ValidationRules.trimForm });
    if (!$form.valid()) {
      $('.form-control.is-invalid').focus();
      if ($('.is-invalid').length) {
        $('html, body').animate({ scrollTop: $('.is-invalid').first().offset().top - 70 }, 'fast');
      }
      return false;
    }
    UI.block('#page');
    let formData = $form.serializeObject();

    formData.files = App.pageData('currenteditedcontent.files');
    formData.labelSize = mapping.labelSize(formData);
    formData = mapping.trimSave(formData);

    save(formData);
  };

  let save = (formData) => {
    let url = formData.id ? `/trims/update/` : `/trims/create/${formData.accountId}`;
    $.when(App.ajaxData(url, formData, 'POST')) //Getting Brands list
      .done((res) => {
        if (!res.isSuccess) {
          if (res.validationErrors) {
            let template = require('./tmpl/dialog/validationDialog.hbs');
            let title = '';

            switch (res.validationErrors[0].errorType) {
              case 1:
                title = $lang.trims.FilesMissing;
                break;
              default:
                title = $lang.trims.Error;
                break;
            }
            bootbox.dialog({
              size: 'medium',
              title: title,
              value: null,
              message: template(res.validationErrors),
              buttons: {
                cancel: {
                  label: $lang.btn.gotIt,
                  className: 'btn btn-hover-dark bbw-border-radius btn-primary',
                  callback: function () {
                    UI.unblock('#page');
                  }
                }
              }
            });

            UI.unblock('#page');
            return UI.unblock('.modal-content');
          } else {
            return UI.errorMessage(res.errorInformation.errorReason);
          }
        }

        App.pageData($config.GLOBAL.UNSAVED_CHANGES, false);

        $router.push({
          pathname: '/trims',
          query: { restoreQuery: null }
        });
        UI.notify({
          text: $lang.alert.SuccessfullySaved,
          icon: 'fal fa-check-circle',
          type: 'success'
        });
      })
      .always(() => {
        UI.block('#page');
      });
  };

  let deleteTrim = (id = false, accountId, isConfirm = false) => {
    let selectTrims = App.pageData('selectTrims') || [];
    let selectAllTrims = App.pageData('selectAllTrims') || false;
    let trims = App.pageData('trims') || [];

    let idsCollection = {};

    if (id) {
      const trim = trims.find(t => t.id === id);

      if (trim) {
        idsCollection[id] = trim?.accountId;
      }
    } else {
      idsCollection = selectTrims.reduce((acc, trim) => {
        acc[trim.id] = trim.accountId;
        return acc;
      }, {});
    }

    if (!Object.keys(idsCollection).length) {
      return;
    }

    UI.block('#page');

    $.when(App.ajaxData('/trims/delete', { ids: idsCollection, isConfirm: isConfirm }, 'POST')).done((res) => {
      if (res.confirmText) {
        bootbox.confirm({
          message: `<h4 class="text-danger">${res.confirmText}</h4>`,
          buttons: {
            confirm: {
              label: 'Yes',
              className: 'btn-success'
            },
            cancel: {
              label: 'No',
              className: 'btn-danger'
            }
          },
          callback: function (result) {
            if (result) {
              deleteTrim(id, accountId, true);
            } else {
              UI.unblock('#page');
            }
          }
        });
      } else {
        if (id) {
          // If was selected - remove from selected Array
          selectTrims = selectTrims.filter((item) => item.id != id);
        } else {
          selectTrims = [];
        }

        UI.notify({ text: $lang.alert.SuccessfullySaved, type: 'success' });

        App.pageData('selectAllTrims', selectAllTrims);
        App.pageData('selectTrims', selectTrims);
        reloadPage();
      }
    });
  };

  let selectAll = (event) => {
    let isCheked = $(event.currentTarget).prop('checked');
    App.pageData('selectAllTrims', isCheked);
    if (!isCheked) {
      App.pageData('selectTrims', []);
      return;
    }

    UI.block('#page');
    $.when(App.ajaxData(`/trims/select/all/${User.accountID()}`, {}, 'POST'))
      .done((res) => {
        App.pageData('selectTrims', res.data);
      })
      .always(() => {
        UI.unblock('#page');
      });
  };

  let approveReject = (e) => {
    let target = $(e.target).hasClass('js-action-approvereject')
      ? $(e.target)
      : $(e.target).closest('.js-action-approvereject');
    let id = target.data('itemid');
  
    const singleItem = id ? App.pageData('trims').find((i) => i.id == id) : null;
    const selectedItems = singleItem ? [singleItem] : App.pageData('selectTrims');
    const mapped = selectedItems.reduce((acc, item) => ({ ...acc, [item.id]: item.accountId }), {});
    
    ApprovalRejection.dialog({
      items: mapped,
      page: 'trims',
      callback: reloadPageWithClearingSelectAll
    });
  };

  let goToArtworks = (pageData, e) => {
    let parms = {
      action: 'dialog',
      withTrims: true,
      callback: pageData.callback,
    };

    return Artworks.init(parms);
  };

  return {
    init,
    pageinit,
    deleteTrim,
    selectAll,
    trimsLoadDialog,
    stampsLoadDialog,
    assignTask
  };
})();
